import Card from '@zenbusiness/zui/Card';
import CardContent from '@zenbusiness/zui/CardContent';
import { superstyled } from '@zenbusiness/zui/styles';

export const CardWrapper = superstyled({
  name: 'ZuiCard',
  slot: 'Root',
  tag: Card,
  styles: () => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  })
});

export const ContentWrapper = superstyled({
  name: 'ZuiContentWrapper',
  slot: 'ContentWrapper',
  tag: CardContent,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    height: '100%'
  })
});
